/**
 * mise利用状況APIクライアント
 */

import { AuthenticatedApiClient } from '../client';
import type { UsageResponse } from '@/lib/types/mise/usage';

/**
 * mise利用状況を取得（認証付き）
 */
export async function getUsageAuthenticated(
  authHeaders: Record<string, string>,
  params: {
    start_date: string;
    end_date: string;
    company_id?: string;
  },
): Promise<UsageResponse> {
  try {
    const client = new AuthenticatedApiClient(authHeaders);
    const queryParams = new URLSearchParams();
    queryParams.append('start_date', params.start_date);
    queryParams.append('end_date', params.end_date);
    if (params.company_id) {
      queryParams.append('company_id', params.company_id);
    }

    const url = `/mise/usage?${queryParams.toString()}`;
    const usage = await client.get<UsageResponse>(url);
    return usage;
  } catch (error) {
    console.error('Failed to fetch mise usage:', error);
    throw error;
  }
}
